import { useState } from 'react';

export default function IssuesSection({ issues }) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="flex-shrink-0" style={{ borderTop: '1px solid var(--color-border-default)' }}>
      {/* Expanded Issues List */}
      {isExpanded && (
        <div className="max-h-64 overflow-y-auto" style={{ borderBottom: '1px solid var(--color-border-default)' }}>
          {issues.map((issue) => (
            <div
              key={issue.id}
              className="p-3 last:border-b-0 transition-colors"
              style={{ borderBottom: '1px solid var(--color-border-default)' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--color-bg-hover)'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h4 className="text-sm font-semibold mb-1" style={{ color: 'var(--color-text-primary)' }}>{issue.title}</h4>
                  <p className="text-xs" style={{ color: 'var(--color-text-muted)' }}>{issue.collection}</p>
                </div>
                <span className={`ml-2 px-2 py-0.5 rounded text-xs font-semibold flex-shrink-0 ${
                  issue.severity === 'high'
                    ? 'bg-red-500/20 text-red-400'
                    : issue.severity === 'medium'
                    ? 'bg-yellow-500/20 text-yellow-400'
                    : 'bg-blue-500/20 text-blue-400'
                }`}>
                  {issue.severity}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Header */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-4 py-5 transition-colors flex items-center justify-between"
        style={{
          background: 'linear-gradient(135deg, var(--color-bg-tertiary), var(--color-bg-secondary))'
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = 'linear-gradient(135deg, var(--color-bg-hover), var(--color-bg-tertiary))'}
        onMouseLeave={(e) => e.currentTarget.style.background = 'linear-gradient(135deg, var(--color-bg-tertiary), var(--color-bg-secondary))'}
      >
        <div className="flex items-center space-x-2">
          <svg
            className={`w-4 h-4 transform transition-transform duration-200 ${
              isExpanded ? 'rotate-180' : ''
            }`}
            style={{ color: 'var(--color-text-muted)' }}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
          </svg>
          <span className="font-semibold text-sm" style={{ color: 'var(--color-text-primary)' }}>Issues</span>
          <span className="px-2 py-0.5 bg-red-500/20 text-red-400 rounded text-xs font-semibold">
            {issues.length}
          </span>
        </div>
      </button>
    </div>
  );
}
